import React from 'react'

import { useTheme } from '@material-ui/core'

import { Container } from '../../components'
import { currencyFormatter } from '../../helpers'
import { useUser } from '../../hooks'
import {
    PortfolioSchedule,
    SEE_VENDOR_FINANCES,
    WorkorderAnalyticDict,
} from '../../models'
import { hasPermission } from '../../models/Users/services'
import { typographyStyle } from '../../theme/typographyStyle'

interface Props {
    schedule?: PortfolioSchedule
    analyticDict: WorkorderAnalyticDict
}

export const PortfolioScheduleAnalytics = (props: Props) => {
    const { schedule, analyticDict } = props

    const theme = useTheme()
    const { workspaceUser } = useUser()
    return (
        <Container
            style={{
                flex: 1,
                flexWrap: 'wrap',
                flexDirection: 'row',
            }}
        >
            {hasPermission(workspaceUser, SEE_VENDOR_FINANCES) && (
                <Container
                    style={{
                        flexDirection: 'column',
                        flex: 1,
                        marginRight: theme.spacing(4),
                    }}
                >
                    <span
                        style={{
                            ...typographyStyle(theme.typography.body1),
                            fontWeight: 300,
                        }}
                    >
                        Set Budget:{' '}
                        <span
                            style={{
                                fontWeight: 700,
                            }}
                        >
                            {currencyFormatter.format(
                                schedule?.baseline_budget ?? 0,
                            )}
                        </span>
                    </span>

                    <span
                        style={{
                            ...typographyStyle(theme.typography.body1),
                            fontWeight: 300,
                        }}
                    >
                        Forecasted:{' '}
                        <span
                            style={{
                                fontWeight: 700,
                            }}
                        >
                            {currencyFormatter.format(
                                analyticDict.forecastedBudget,
                            )}
                        </span>
                    </span>
                    <span
                        style={{
                            ...typographyStyle(theme.typography.body1),
                            fontWeight: 300,
                        }}
                    >
                        Invoiced Budget:{' '}
                        <span
                            style={{
                                fontWeight: 700,
                            }}
                        >
                            {currencyFormatter.format(
                                analyticDict.invoicedBudget,
                            )}
                        </span>
                    </span>
                    <span
                        style={{
                            ...typographyStyle(theme.typography.body1),
                            fontWeight: 300,
                        }}
                    >
                        Invoiced Out Budget:{' '}
                        <span
                            style={{
                                fontWeight: 700,
                            }}
                        >
                            {currencyFormatter.format(
                                analyticDict.invoicedOutBudget,
                            )}
                        </span>
                    </span>

                    <span
                        style={{
                            ...typographyStyle(theme.typography.body1),
                            fontWeight: 300,
                        }}
                    >
                        Total Invoiced Budget:{' '}
                        <span
                            style={{
                                fontWeight: 700,
                            }}
                        >
                            {currencyFormatter.format(
                                analyticDict.invoicedBudget +
                                    analyticDict.invoicedOutBudget,
                            )}
                        </span>
                    </span>
                </Container>
            )}

            <Container
                style={{
                    flexDirection: 'column',
                    marginRight: theme.spacing(4),
                    flex: 1,
                }}
            >
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Total Units:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.unitCount}
                    </span>
                </span>
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Unassigned Occ Units:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {schedule?.unassigned_occupiable_units ?? 0}
                    </span>
                </span>
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Total Work Orders:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.workorderCount}
                    </span>
                </span>
            </Container>

            <Container
                style={{
                    flexDirection: 'column',
                    marginRight: theme.spacing(4),
                    flex: 1,
                }}
            >
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Not Started:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.notStarted}
                    </span>
                </span>
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    In Progress:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.IN_PROGRESS +
                            analyticDict.PAUSE +
                            analyticDict.GO_BACK}
                    </span>
                </span>
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Complete:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.COMPLETE}
                    </span>
                </span>
            </Container>

            <Container
                style={{
                    flexDirection: 'column',
                    marginRight: theme.spacing(4),
                    flex: 1,
                }}
            >
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Approved:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.APPROVED}
                    </span>
                </span>
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Invoiced:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.INVOICED}
                    </span>
                </span>

                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Invoice Request:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.INVOICE_REQUEST}
                    </span>
                </span>

                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Invoiced Out:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.INVOICED_OUT}
                    </span>
                </span>

                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Behind Count:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.behindTrack}
                    </span>
                </span>
            </Container>

            <Container
                style={{
                    flexDirection: 'column',
                    marginRight: theme.spacing(4),
                    flex: 1,
                }}
            >
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Ghost count:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.ghostCount}
                    </span>
                </span>
                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Services Areas:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.serviceAreaCount}
                    </span>
                </span>

                <span
                    style={{
                        ...typographyStyle(theme.typography.body1),
                        fontWeight: 300,
                    }}
                >
                    Ghost Service Areas:{' '}
                    <span
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        {analyticDict.ghostServiceAreaCount}
                    </span>
                </span>

                <div style={{ flex: 1 }} />
            </Container>
        </Container>
    )
}
